module.exports = __webpack_public_path__ + "img/big-remnants-ground-patch.7dfd11a9.png";